// Generate (and persist) a stable per-browser device ID.
// Used for friendly per-device quotas — NOT for security. Anyone can clear
// localStorage and bypass it. That's fine; we just want to stop lazy abuse.

import { useEffect, useState } from 'react'

const KEY = 'peak.device_id'

function uuid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
  return 'd_' + Math.random().toString(36).slice(2) + Date.now().toString(36)
}

export function useDeviceId() {
  const [id, setId] = useState(() => {
    try {
      const stored = localStorage.getItem(KEY)
      if (stored) return stored
      const fresh = uuid()
      localStorage.setItem(KEY, fresh)
      return fresh
    } catch {
      return uuid()
    }
  })

  useEffect(() => {
    function onStorage(e) {
      if (e.key === KEY && e.newValue) setId(e.newValue)
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  return id
}
